import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionMenuFetchListPayload,
	IActionMenuFetchListPayloadDone,
	IActionMenuFetchListPayloadError,
} from './types';

export const menuFetchList = actionCreatorAsync<
	IActionMenuFetchListPayload,
	IActionMenuFetchListPayloadDone,
	IActionMenuFetchListPayloadError
>(
	'menuFetchList',
	async (params) => {
		const { startTime, endTime } = params;
		const { data } = await Api.menu.fetchList({
			params: { startTime, endTime },
		});

		return data;
	},
);
